import type { SecurityService } from './index';
import type { ShipiumOauthClient, CreateOauthClientResponse } from './types';
import { mockedOauthClients, newOauthClientRes, mockedAuthorities, mockedApiKeys } from './MockedResponses';

const delay = (duration = 1000) => new Promise((resolve) => setTimeout(resolve, duration));
export const mockSecurityService: SecurityService = {
  getPartnerOauthClients: async (partnerId: string) => {
    await delay(1000);
    return mockedOauthClients;
  },
  createPartnerOauthClient: async (partnerId: string, name: string): Promise<CreateOauthClientResponse> => {
    newOauthClientRes.oauthClient.name = name;
    await delay(1000);
    return newOauthClientRes;
  },
  resetPartnerOauthClient: async (
    partnerId: string,
    client: ShipiumOauthClient,
  ): Promise<CreateOauthClientResponse> => {
    await delay(1000);
    return { oauthClient: client, oauthClientSecret: 'newResetSecret' };
  },
  updatePartnerOauthClient: async (partnerId: string, client: ShipiumOauthClient): Promise<ShipiumOauthClient> => {
    await delay(1000);
    return client;
  },
  getAuthorities: async () => {
    return mockedAuthorities;
  },
  getApiKeys: async (payload: any) => {
    await delay(1000);
    return mockedApiKeys;
  },
  createPartnerApiKey: async (partnerId: string, name: string) => {
    return {
      active: true,
      apiKey: 'key1234',
      apiKeyId: 'key_id_1234',
      createdBy: 'Marquis Mark',
      creationTimeStamp: '2021-03-09T01:54:28.678Z',
      lastUpdatedBy: 'Marquis Mark',
      lastUpdatedTimeStamp: '2021-03-09T01:54:28.678Z',
      metadata: {
        additionalProp1: 'string',
        additionalProp2: 'string',
        additionalProp3: 'string',
      },
      name,
    };
  },
  updatePartnerApiKey: async (partnerId: any, apiKey: any) => {
    return apiKey;
  },
};
